/**
 * @param {string} text
 * @param {string} isin
 * @returns {HTMLLiElement}
 */
export function renderQuickSearchElement(text, isin) {
  const listElement = document.createElement('li')
  const button = document.createElement('button')
  listElement.appendChild(button)

  const nameSpan = document.createElement('span')
  nameSpan.innerHTML = text
  button.appendChild(nameSpan)

  const isinSpan = document.createElement('span')
  isinSpan.innerHTML = isin
  button.appendChild(isinSpan)

  return listElement
}